export default __webpack_public_path__ + "static/hero-pattern-orange-small-5cee420d24227a0a2ad7dc485ddd90f0.svg";